import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IssuesFilterSupplier, QuproList, CsiteSupplier, IssuesOrderSupplier, IssueOrderSupplierType, IssueSupplier } from '@arpada/arp-lib-common-qupro';

import { PortalProveedorService, MessagesService, GeneralPopulateService, IssuePopulateService } from '../../services/api.services';
import { DatatableMessage, IssueFront, FuturaLineaProformaFront } from '../../models/api.models';

import { IssueProformableData } from './issue.proformable.data';
import { SendClickEventEmitter } from './send.click.event.emitter';
import { ActionsSharedData } from '../shared/actions-header/actions.shared.data';


@Component({
  selector: 'app-issues-proformables',
  templateUrl: './issues-proformables.component.html',
  styleUrls: ['./issues-proformables.component.scss'],
})
export class IssuesProformablesComponent implements OnInit {

  @Input() csite: CsiteSupplier;
  csiteId: number;

  issues: IssueSupplier[];
  issuesFrontSelected: IssueFront[] = [];
  proformasToCreate: FuturaLineaProformaFront[] = [];

  sharedData: ActionsSharedData = new ActionsSharedData();
  issuesFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
  issuesOrder: IssuesOrderSupplier = new IssuesOrderSupplier(IssueOrderSupplierType.DEFAULT_ORDER);
  issueProformableData: IssueProformableData = new IssueProformableData();
  showList = true;
  filtroIssueProformable = true;
  showCrearProformablesTable = false;
  showResumenProformaTable = false;

  totalCountNumber = -1;
  totalCount = '-';

  constructor(private portalProveedorService: PortalProveedorService,
              private messages: MessagesService,
              private generalPopulateService: GeneralPopulateService,
              public activatedRouter: ActivatedRoute,
              private issuePopulateService: IssuePopulateService) {
    this.initIssueProformableData();
  }

  ngOnInit() {
    this.activatedRouter.params.subscribe(params => {
      // tslint:disable-next-line: no-string-literal
      this.csiteId  = Number(params['id']);
      this.portalProveedorService.getCsiteOfSupplierByCsiteId(this.csiteId, 'combo-proformable-proveedor').subscribe(resp => {
        resp.elements.forEach(csite => {
          if (this.csiteId === csite.id) {
            this.csite = csite;
            // this.csiteId = csite.id;
            this.initFilter(this.csiteId);
            this.setTotalCount(-1);
            this.messages.onInitTranslateService().subscribe( () => {
              this.getIssues();
            });
          }
        });
      });
    });
    this.portalProveedorService.getTituloEvent.emit('menu.title.newProforma');
  }

  onFilterChange(filtroRecibido) {
    const filterTemp = new IssuesFilterSupplier();
    Object.assign(filterTemp, filtroRecibido);
    this.issuesFilter = filterTemp;
    this.getIssues();
  }

  onRowSelected(issuesFrontReceived: IssueFront[]) {
    if (issuesFrontReceived) {
      this.issuesFrontSelected = issuesFrontReceived;
    } else {
      this.issuesFrontSelected = [];
    }
  }

  onNextClicked(clicked: SendClickEventEmitter) {
    if (clicked.tabla === 'issues-proformables-escritorio') {
      this.showCrearProformablesTable = true;
      this.showList = false;
      this.showResumenProformaTable = false;
      this.proformasToCreate = clicked.proformasToCreate;
    }
    if (clicked.tabla === 'crear-proformable-escritorio') {
      this.showCrearProformablesTable = false;
      this.showList = false;
      this.showResumenProformaTable = true;
      this.proformasToCreate = clicked.proformasToCreate;
    }
  }

  onBackClicked(clicked: SendClickEventEmitter) {
    if (clicked.tabla === 'crear-proformable-escritorio') {
      this.showCrearProformablesTable = false;
      this.showList = true;
    }
    if (clicked.tabla === 'resumen-proformable-escritorio') {
      this.showCrearProformablesTable = true;
      this.showResumenProformaTable = false;
      this.showList = false;
    }

  }

  private getIssues() {
    const start = 0;
    const limit = 0; // en este caso no queremos paginacion
    this.issueProformableData.msg.emptyMessage = this.generalPopulateService.changeMms(true);
    this.issueProformableData.loading = true;
    this.portalProveedorService.getIssuesProformablesFromCsiteSupplier(this.issuesFilter,
      this.issuesOrder, start, limit).subscribe((resp: QuproList<IssueSupplier>) => {
        this.setTotalCount(resp.count);
        this.issues = resp.elements;
        // console.log('issues: ', this.issues);
        const temporal = this.issuePopulateService.convertirIssuesSupplierToIssuesProformablesFront(this.issues);
        this.issueProformableData.issuesFront = temporal;
        this.issueProformableData.loading = false;
        this.issueProformableData.msg.emptyMessage = this.generalPopulateService.changeMms(false);
      });
  }

  private initIssueProformableData() {
    this.issueProformableData.issuesFront = [];
    this.issueProformableData.selected = [];
    this.issueProformableData.loading = true;
    this.issueProformableData.msg = new DatatableMessage();
    this.issueProformableData.msg.emptyMessage = '';
    this.issueProformableData.msg.totalMessage = 'total';
  }

  private initFilter(csiteId?: number) {
    const newFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
    if (csiteId) {
      newFilter.csite_id = csiteId;
    }
    // Assign all fields to actual filter
    Object.assign(this.issuesFilter, newFilter);
  }

  private setTotalCount(totalCountNumber: number) {
    this.totalCountNumber = totalCountNumber;
    if (totalCountNumber >= 0) {
      this.totalCount = totalCountNumber + '';
      this.sharedData.totalCount = totalCountNumber + '';
    } else {
      this.totalCount = '-';
      this.sharedData.totalCount = '-';
    }
  }
}
